import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProjectDetailComponent } from './detail/detail.component';
import { ProjectListComponent } from './list/list.component';

const projectRoutes: Routes = [
    {path: 'projects', component: ProjectListComponent},
    {path: 'project/:id', component: ProjectDetailComponent},
];

@NgModule({
    imports: [
        RouterModule.forChild(projectRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class ProjectRoutingModule {
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/project-routing.module.ts